/*
登录记录页面相关api
 */
import request from '@/api/request';
export const loginRecordApi = {
  /**
   *获取登录记录
   * data => {
   *  page // 當前页码
      size // 每页显示条数
   * }
   */
  getLoginRecord(data) {
    return request.get('/gw/w/login/history', {
      params: data,
    });
  },
  /**
   *获取用户操作记录（安全设置历史）
   * data => {
   *  page // 當前页码
      size // 每页显示条数
   * }
   */
  getSecurityRecord(data) {
    return request.get('/gw/w/activities/history', {
      params: data,
    });
  },
};
